// One place for the shape of a stored survey answer.
//
// interactions_survey_responses.responses_json maps question id → answer:
//   - multiple_choice (single):  the chosen option, a string
//   - multiple_choice (several): the chosen options, a string[]  (allow_multiple)
//   - nps:                       a number 0–10
//   - text:                      a string
// Shared by the fan page (collecting/validating) and every reader (Insights
// drill panel, Insights and Reporting exports) so a list never leaks out as
// raw JSON.

export type SurveyAnswer = string | number | string[];

/** Human-readable answer for a table cell; lists are joined, blanks are ''. */
export function formatSurveyAnswer(value: unknown): string {
  if (value == null || value === '') return '';
  if (Array.isArray(value)) return value.map((v) => String(v)).join('; ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

/** A required question is unanswered when nothing was chosen or typed. 0 (NPS) counts as answered. */
export function isSurveyAnswerMissing(value: unknown): boolean {
  if (value === undefined || value === null || value === '') return true;
  return Array.isArray(value) && value.length === 0;
}

/** Tick or untick one option of a several-answers question; never duplicates. */
export function toggleSurveyOption(current: unknown, option: string, checked: boolean): string[] {
  const list = Array.isArray(current)
    ? current.map((v) => String(v))
    : typeof current === 'string' && current !== ''
      ? [current]
      : [];
  if (checked) return list.includes(option) ? list : [...list, option];
  return list.filter((v) => v !== option);
}
